import { applyMiddleware, compose, createStore } from 'redux';
import { useRouterHistory } from 'react-router';
import { syncHistory } from 'react-router-redux';
import thunk from 'redux-thunk';
import { createHistory } from 'history';

import api from './middleware/api';
import rootSearchUnitReducer from './rootSearchUnitReducer';

const history = useRouterHistory(createHistory)({ basename: '' });

export function configureStore() {
  const initState = window.__INITIAL_STATE__ || {};

  // Sync with router via history instance (main.js)
  const routerMiddleware = syncHistory(history);

  let middleware = applyMiddleware(thunk, api, routerMiddleware);


  /* istanbul ignore if */
  if (__DEBUG__) {
    // ignore debug code
    // eslint-disable-next-line global-require
    const devTools = window.devToolsExtension ? window.devToolsExtension() : require('containers/DevTools').default.instrument();
    middleware = compose(middleware, devTools);
  }

  // Create final store and subscribe router in debug env ie. for devtools
  const store = middleware(createStore)(rootSearchUnitReducer, initState);

  /* istanbul ignore if */
  if (__DEBUG__) routerMiddleware.listenForReplays(store, ({ router }) => router.location);

  /* istanbul ignore if */
  if (module.hot) {
    module.hot.accept('./rootSearchUnitReducer', () => {
      // ignore debug code
      // eslint-disable-next-line global-require
      const nextRootReducer = require('./rootSearchUnitReducer').default;

      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}

export default configureStore();



/** WEBPACK FOOTER **
 ** ./src/redux/configureSearchUnitStore.js
 **/